import axios from 'axios';

import { API_URL, JWT_TOKEN, USER_FULL_NAME } from '../constants/config';
import { getLocalStorage, setLocalStorage, clearLocalStorage } from './storageUtil';
import history from '../utils/history';

export const httpBase = (isDownloadable = false) => {
  const headers = {
    'X-XSRF-TOKEN': `${getLocalStorage(JWT_TOKEN) ? getLocalStorage(JWT_TOKEN) : '1002'}`,
    'X-MULTITENANCY-TOKEN': '1002',
  };
  const normalHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  const downloadableHeaders = {
    Accept: '*/*',
    'Content-Type': 'application/json',
  };

  const api = axios.create({
    baseURL: `${API_URL}`,
    headers: isDownloadable
      ? { ...headers, ...downloadableHeaders }
      : { ...headers, ...normalHeaders },
    responseType: isDownloadable ? 'blob' : 'json',
  });

  api.interceptors.response.use(
    (response) => {
      if (response.headers && response.headers['x-xsrf-token']) {
        setLocalStorage(JWT_TOKEN, response.headers['x-xsrf-token']);
      }
      return response;
    },
    (error) => {
      // if (401 === error.response.status) {
      //   clearLocalStorage(JWT_TOKEN);
      //   clearLocalStorage(USER_FULL_NAME);
      //   // history.push('/');
      // }
      // if (404 === error.response.status) {
      //   history.push('/404');
      // }
      // if (500 === error.response.status) {
      //   history.push('/500');
      // }
      return Promise.reject(error);
    }
  );

  return api;
};
